import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import BannerNosotros from "../components/BannerNosotros";
import AboutUs from "../components/AboutUs";
import MisionVision from "../components/MisionVision";

export default function Nosotros() {
  return (
    <main style={{ fontFamily: "Inter, Roboto, sans-serif", color: "#222", background: "#fff" }}>
        <Header />
        <BannerNosotros />
        <AboutUs />
        <MisionVision />
        <Footer />
    </main>
  );
}